<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">
          {{ $tc('delete_ip') }}?
        </v-card-title>
        <v-card-text>
          {{ $t('confirm_ip_delete') }}
          <strong>{{ ip }}</strong>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="green darken-1" text @click.native="closeModal">
            {{ $t('cancel') }}
          </v-btn>
          <v-btn color="text_red" text @click.native="deleteIp">
            {{ $t('confirm') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>

export default {
  props: {
    ip: {
      type: String,
      required: false,
      default: () => null
    },
    open: {
      type: Boolean,
      required: false,
      default: () => false
    }
  },
  data () {
    return {
      dialog: this.open
    }
  },
  computed: {
    p11Info () {
      return this.$store.state.hsm.p11Info
    }
  },
  methods: {
    closeModal () {
      this.dialog = false
      this.$emit('close')
    },
    deleteIp () {
      let dns0 = this.p11Info.dns1
      let dns1 = this.p11Info.dns2

      if (this.ip === dns0) {
        dns0 = ''
      } else {
        dns1 = ''
      }

      this.$store
        .dispatch('hsm/set_dns', {
          body: {
            dns0,
            dns1
          }
        })
        .then(() => {
          this.$notify.success({})
        })
        .catch(err => {
          const errObj = this.$store.getters['error/getErrorObj'](err)
          if (errObj) {
            this.$notify.hsmError(errObj, err)
          } else {
            this.$notify.error({ message: err })
          }
        })
        .finally(() => {
          this.loading = false
          this.closeModal()
        })
    }
  },
  watch: {
    open (val) {
      this.dialog = val
    }
  }
}
</script>
